
			const zSideCartTemplates = `<template id="scz-cart-container" type="html/text">
      <div scz-cart id="scz-cart-container__js" class="scz-cart-container scz-cart-layout-{$=zerance.layout}} scz-cart-spacings-{$=zerance.spacings}}">
          <div class="scz-cart-content-loader__wrapper" style="position:relative;">
            <div class="scz-cart-content-loader" scz-loader>
              <div class="scz-cart-content-loader-container">
                <div class="scz-cart-loader"><div></div><div></div><div></div><div></div></div>
              </div>
            </div>
          </div>
          <div data-cart-top>
  
          </div>
  
          <div data-cart-middle>
  
          </div>
  
          <div data-cart-bottom>
  
          </div>
      </div>
  </template>
  
  <template id="scz-cart-overlay" type="html/text">
    <div scz-cart-overlay id="scz-cart-overlay__js" class="scz-cart-overlay" style="opacity: {$=zerance.opacity}}"></div>
  </template>
  
  <script id="scz-cart-non_native_recharge_item" type="template/x-dotjs">
      {$? zerance.options.grouping.enabled }}
        {$? zerance.options.grouping.title }}
          <p class="scz-cart-item__grouping-title">{$=zerance.options.grouping.title}}</p>
        {$?}}
      {$?}}
      <div id="{$=zerance.id}}"
        {$#def.block_attributes}}
         scz-cart-item class="scz-cart-item__container">
        <div class="scz-cart-item__content">
          <div class="scz-cart-item">
  
            {$##def.image:
              <img class="scz-cart-item__image" src="{$=zerance.line_item.image}}" alt="{$=zerance.line_item.handle}}">
            #}}
  
            {$? zerance.options.link_product.image }}
              <a href="{$=zerance.original_product.url}}">
                {$#def.image}}
              </a>
            {$??}}
              <div class="scz-cart-item__image-container">
                {$#def.image}}
              </div>
            {$?}}
  
            <div class="scz-cart-item-info-container">
              <div class="scz-cart-item__info">
                {$? zerance.options.link_product.title }}
                    <a class="scz-cart-item__title" href="{$=zerance.original_product.url}}">
                      {$=zerance.original_product.title }}
                    </a>
                  {$??}}
                    <div class="scz-cart-item__title">
                      {$=zerance.original_product.title }}
                    </div>
                  {$?}}
  
                  <div class="scz-cart-item__description">
                    {$? zerance.line_item.variant_title && zerance.line_item.variant_title != "Default Title" }}
                      {$=zerance.line_item.variant_title}}
                    {$?}}
                  </div>
  
                  {$? zerance.options.popupActions.update && zerance.options.popupActions.update.enabled && zerance.line_item.variant_options.length > 0 }}
                    <div scz-cart-popup-trigger-update scz-cart-popup-product-handle="{$=zerance.line_item.handle}}" class="scz-cart-item__edit" style="width: fit-content; margin-bottom: 10px;">{$=zerance.options.popupActions.update.label}}</div>
                  {$?}}
  
                  <div class="">
                    {$#def.quantity_template}}
                  </div>
              </div>
  
              <p class="scz-cart-item__original-price">
                {$=zerance.line_item.original_line_price | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}
              </p>
  
              <div class="scz-cart-item__remove-container">
                {$#def.remove_template}}
              </div>
  
              {$? zerance.options.removeSubscription && zerance.options.removeSubscription.enabled }}
                <div scz-cart-remove-subscription class="scz-cart-subscription-box">
                  <div class="scz-cart-subscription-box-content">
                    <div class="scz-cart-subscription-box-checkbox">
                      <input type="checkbox" name="item_subscribed" id="item_subscribed" checked="checked">
                      <label for="item_subscribed"></label>
                    </div>
                    <span class="scz-cart-subscription-box-label pls">{$=zerance.options.removeSubscription.label}}</span>
                  </div>
                  <div class="scz-cart-subscription-box-content">
                    <span class="prs">Livraison tous les {$=zerance.line_item.properties.shipping_interval_frequency}} {$=zerance.line_item.properties.shipping_interval_unit_type | __ascf.dateUnitFormatter: zerance.line_item.properties.shipping_interval_unit_type }}</span>
                  </div>
                </div>
              {$?}}
            </div>
          </div>
        </div>
  
        {$? zerance.options.remove.enable_swiping_on_mobile }}
          <div class="scz-cart-item__swipping-remove">
            {$#def.remove_template}}
          </div>
        {$?}}
      </div>
    </script>
  
  <template id="scz-cart-accordion">
      <div id="{$=zerance.id}}" scz-cart-accordion class="scz-cart-accordion">
        {$~zerance.panels :value:index}}
          <div class="scz-cart-accordion-item">
            <div class="scz-cart-accordion-title" scz-accordion-title-tab="{$=zerance.id}}-tab-{$=index}}">
              {$=value.tab_title}}
              {$? zerance.display_icon }}
                <span class="scz-cart-accordion-icon-{$=zerance.icon}}"></span>
              {$?}}
            </div>
            <div class="scz-cart-accordion-content" scz-accordion-content id="{$=zerance.id}}-tab-{$=index}}">
              {$=value.tab_description}}
            </div>
          </div>
        {$~}}
      </div>
  </template>
  <script id="scz-cart-basic_item" type="template/x-dotjs">
    {$? zerance.options.grouping.enabled }}
      {$? zerance.options.grouping.title }}
        <p class="scz-cart-item__grouping-title">{$=zerance.options.grouping.title}}</p>
      {$?}}
    {$?}}
    <div id="{$=zerance.id}}"
      {$#def.block_attributes}}
       scz-cart-item class="scz-cart-item__container">
      <div class="scz-cart-item__content">
        <div class="scz-cart-item">

          <div class="scz-cart-item__remove-container">
            {$#def.remove_template}}
          </div>
  
          {$##def.image:
            <img class="scz-cart-item__image" src="{$=zerance.line_item.image}}" alt="{$=zerance.line_item.handle}}">
          #}}
  
          {$? zerance.options.link_product.image }}
            <a class="scz-cart-item__image-container" href="{$=zerance.line_item.url}}">
              {$#def.image}}
            </a>
          {$??}}
            <div class="scz-cart-item__image-container">
              {$#def.image}}
            </div>
          {$?}}
  
          <div class="scz-cart-item-info-container">
            <div class="scz-cart-item__info">
                <div>
                  {$? zerance.options.link_product.title }}
                    <a class="scz-cart-item__title" href="{$=zerance.line_item.url}}">
                      {$=zerance.line_item.product_title}}
                    </a>
                  {$??}}
                    <div class="scz-cart-item__title">
                      {$=zerance.line_item.product_title}}
                    </div>
                  {$?}}
  
                  <div class="scz-cart-item__description">
                    {$? zerance.line_item.variant_title && zerance.line_item.variant_title != "Default Title" }}
                      {$=zerance.line_item.variant_title}}
                    {$?}}
                  </div>
  
                  {$? zerance.options.popupActions.update && zerance.options.popupActions.update.enabled && zerance.line_item.variant_options.length > 0 && zerance.line_item.variant_title && zerance.line_item.variant_title != "Default Title" }}
                    <div scz-cart-popup-trigger-update scz-cart-popup-product-handle="{$=zerance.line_item.handle}}" class="scz-cart-item__edit" style="width: fit-content; margin-bottom: 10px;">{$=zerance.options.popupActions.update.label}}</div>
                  {$?}}
                </div>
  
                <div class="scz-cart-item__info-row">

                  {$#def.quantity_template}}

                  <div class="scz-cart-item__prices-wrap">

                    {$? zerance.line_item.compare_at_price && (zerance.line_item.compare_at_price * zerance.line_item.quantity) > zerance.line_item.original_line_price }}
                      <p class="scz-cart-item__compare-price">
                        {$=(zerance.line_item.compare_at_price * zerance.line_item.quantity) | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}
                      </p>
                    {$??}}
                      {$? zerance.line_item.original_line_price && zerance.line_item.original_line_price > zerance.line_item.final_line_price }}
                        <p class="scz-cart-item__compare-price">
                          {$=zerance.line_item.original_line_price | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}
                        </p>
                      {$?}}
                    {$?}}

                    {$? zerance.line_item.final_line_price }}
                      <p class="scz-cart-item__original-price">
                        {$=zerance.line_item.final_line_price | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}
                      </p>
                    {$?}}

                  </div>

                </div>
            </div>
  
  
            {$? zerance.options.popupActions.convertSubscription && zerance.options.popupActions.convertSubscription.enabled && zerance.line_item.metafields && zerance.line_item.metafields.shipping_interval_frequency }}
              <div scz-cart-popup-trigger-subscription scz-cart-popup-product-handle="{$=zerance.line_item.handle}}" class="scz-cart-subscription-box">
                <div class="scz-cart-subscription-box-content">
                  <div class="scz-cart-subscription-box-checkbox">
                    <input type="checkbox" name="item_subscribed" id="item_subscribed">
                    <label for="item_subscribed"></label>
                  </div>
                  <span class="scz-cart-subscription-box-label pls">{$=zerance.options.popupActions.convertSubscription.label}}</span>
                </div>
                <div class="scz-cart-subscription-box-content">
                  {$? zerance.line_item.metafields }}
                  <span class="scz-cart-popup-subscription-product-price prs">{$=zerance.line_item.original_line_price * ((100 - zerance.line_item.metafields.discount_percentage) / 100) | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}</span>
                  {$?}}
                  <span class="scz-cart-popup-subscription-product-compare-price">{$=zerance.line_item.original_line_price | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}</span>
                </div>
              </div>
            {$?}}
          </div>
        </div>
      </div>
  
      {$? zerance.options.remove.enable_swiping_on_mobile }}
        <div class="scz-cart-item__swipping-remove">
          {$#def.remove_template}}
        </div>
      {$?}}
    </div>
    </script>
  
  <template id="scz-cart-button">
    <div id="{$=zerance.id}}" scz-cart-button class="scz-cart-button {$? zerance.active_hover }}scz-cart-button-hover{$?}} scz-cart-button__container-{$=zerance.button_align}} scz-cart-button__wrapper-{$=zerance.width}}">
      <a href="{$=zerance.url}}">
         <div class="scz-cart-button__wrapper scz-cart-button__wrapper-{$=zerance.text_align}}">{$=zerance.title}}</div>
      </a>
    </div>
  </template>
  
  <script id="scz-cart-featured_upsell" type="template/x-dotjs">
      <div id="{$=zerance.id}}" class="scz-cart-featured_upsell {$? zerance.should_hide }} {$=zerance.hide_class}} {$?}}">
  
        {$? zerance.title }}
          <h2 class="scz-cart-featured_upsell__title">
              {$=zerance.title}}
          </h2>
        {$?}}
  
        {$? zerance.style == "checkbox" }}
        <label for="{$=zerance.id}}-input" class="scz-cart-featured_upsell__label">
          <div class="scz-cart-featured_upsell__label-flex">
            <p>{$=zerance.input_label}}</p>
            {$? zerance.description }}
              <span class="scz-cart-featured_upsell__label-tooltip">
                <div class="scz-cart-featured_upsell__label-tooltip-text">?</div>
                <div class="scz-cart-featured_upsell__description">{$=zerance.description}}</div>
                </span>
            {$?}}
          </div>
          {$? zerance.product_price }}
          <div class="scz-cart-featured_upsell__label-price">{$=zerance.product_price}}</div>
          {$?}}
          <input id="{$=zerance.id}}-input" scz-featured-upsell-input class="scz-cart-featured_upsell__input" type="checkbox" name="featured_upsell" {$=zerance.input_attr}} {$? zerance.is_checked }}checked="checked"{$??}}{$?}}>
          <span class="scz-cart-featured_upsell__checkmark"></span>
        </label>
        {$?}}
  
        {$? zerance.style == "square" }}
        <input id="{$=zerance.id}}-input" scz-featured-upsell-input class="scz-cart-featured_upsell__input" type="checkbox" name="featured_upsell" {$=zerance.input_attr}} {$? zerance.is_checked }}checked="checked"{$??}}{$?}}>
        <label for="{$=zerance.id}}-input" class="scz-cart-featured_upsell__label scz-cart-featured_upsell__square">
          <div class="scz-cart-featured_upsell__image">
            {$? zerance.image }}
            <img src="{$=zerance.image}}" alt="{$=zerance.input_label}}">
            {$?}}
          </div>
          <div>
            <div class="scz-cart-featured_upsell__label-flex">
              <p>{$=zerance.input_label}}</p>
              {$? zerance.description }}
                <span class="scz-cart-featured_upsell__label-tooltip">
                  <div class="scz-cart-featured_upsell__label-tooltip-text">?</div>
                  <div class="scz-cart-featured_upsell__description">{$=zerance.description}}</div>
                  </span>
              {$?}}
            </div>
            {$? zerance.product_price }}
            <div class="scz-cart-featured_upsell__label-price">{$=zerance.product_price}}</div>
            {$?}}
          </div>
          <span class="scz-cart-featured_upsell__checkmark"></span>
        </label>
        {$?}}
  
      </div>
  </script>
  
  <script id="scz-cart-footer" type="template/x-dotjs">
  
      {$##def.checkoutBoutonNoSubscriptionStyle:
         <style>
           .scz-cart-button-checkout-no-subscribe {
             display: block;
           }
           .scz-cart-button-checkout-subscribe {
             display: none;
           }
         </style>
      #}}
  
      {$##def.checkoutBoutonSubscriptionStyle:
         <style>
           .scz-cart-button-checkout-no-subscribe {
             display: none !important;
           }
           .scz-cart-button-checkout-subscribe {
             display: block !important;
           }
         </style>
      #}}
  
  
    {$? zerance.cartIsEmpty }}
    <div id="{$=zerance.id}}"></div>
    {$?}}
  
    {$? !zerance.cartIsEmpty }}
    <div id="{$=zerance.id}}" scz-cart-footer class="scz-cart-footer {$? zerance.isFixed }}scz-cart-footer-sticky{$?}}">
  
      {$~zerance.cartShopify.items :item:index}}
         {$? item.properties != null && item.properties.hasOwnProperty('subscription_id') == true }}
           {$#def.checkoutBoutonSubscriptionStyle}}
         {$??}}
           {$#def.checkoutBoutonNoSubscriptionStyle}}
         {$?}}
      {$~}}
  
      <div>
        <div>
          {$? zerance.cart }}
            <a class="scz-cart-button scz-cart-button-checkout" href="/cart">
              <span>{$=zerance.cart.label}}</span>
              {$? zerance.cart.display_total }}
                <span class="button--separator">|</span>
                <span class="button--price">{$=zerance.cart.total | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}</span>
              {$?}}
            </a>
          {$?}}
  
          {$? zerance.checkbox }}
  
            <div class="scz-cart-footer-checkbox">
              <label for="scz-footer-checkbox" class="scz-cart-note__label">
                <div class="scz-cart-footer-checkbox-label">
                  {$=zerance.checkbox.label}}
                </div>
                <input class="scz-cart-footer-checkbox-input" type="checkbox" name="scz-footer-checkbox" id="scz-footer-checkbox" scz-cart__footer-checkbox>
                <span class="scz-cart-footer-checkbox-checkmark"></span>
              </label>
              <p class="scz-cart-footer-checkbox-error" scz-cart__footer-checkbox-error>{$=zerance.checkbox.error}}</p>
            </div>
  
          {$?}}
  
          {$? zerance.checkout }}
            <div class="scz-cart-button-checkout-no-subscribe">
              <a class="scz-cart-button scz-cart-button-checkout" href="/checkout" scz-cart__footer-checkout>
                <span>{$=zerance.checkout.label}}</span>
                {$? zerance.checkout.display_total }}
                  <span class="button--separator">|</span>
                  <span class="button--price">{$=zerance.checkout.total | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}</span>
                {$?}}
              </a>
            </div>
            <div class="scz-cart-button-checkout-subscribe">
              <a href="/checkout" type="submit" name="checkout" class="scz-cart-button scz-cart-button-checkout scz-cart-button-checkout-recharge" scz-cart__footer-checkout scz-data-checkout-cart scz-data-checkout-recharge>
                <span>{$=zerance.checkout.label}}</span>
                {$? zerance.checkout.display_total }}
                  <span class="button--separator">|</span>
                  <span class="button--price">{$=zerance.checkout.total | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}</span>
                {$?}}
              </a>
            </div>
          {$?}}
  
          {$? zerance.additional_checkout }}
            <div class="scz-cart-button-additional_checkout">
              <p scz-cart-button-additional_checkout-title class="scz-cart-button-additional_checkout-title">{$=zerance.additional_checkout.label}}</p>
              <div class="scz-cart-button-additional_checkout-buttons">
                {$=zerance.additional_checkout.buttons}}
  
              </div>
            </div>
          {$?}}
        </div>
      </div>
  
      {$? zerance.tos }}
      <div>
          Title: {$=zerance.tos.title}}
          <br>
          Content: {$=zerance.tos.content}}
          <br>
          Max lines: {$=zerance.tos.number_of_visible_lines}}
      </div>
      {$?}}
  
    </div>
    {$?}}
  </script>
  
  <template id="scz-cart-header">
      <div id="{$=zerance.id}}" scz-cart-header class="scz-cart-header {$? zerance.header_fixed }}scz-cart-header-sticky{$?}}">
        
        <h2 class="scz-cart-header__title">{$=zerance.title}}</h2>

        <div class="scz-cart-header__options">
          {$? zerance.button_close_display }}
            <div scz-cart-close class="scz-cart-header__close">
              {$? zerance.icon_button_close_display == "cross"}}
                <img class="scz-cart-svg" src="https://cdn.shopify.com/s/files/1/0562/8575/7497/files/close_black_24dp.svg?v=1649090633" alt="Delete">
              {$?}}
              {$? zerance.icon_button_close_display == "arrow"}}
                <svg class="scz-cart-svg" width="14" height="23" viewBox="0 0 14 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.8079 0.884094L2.19202 11.5L12.8079 22.1159" stroke="black" stroke-width="2"/>
                </svg>
              {$?}}
            </div>
          {$?}}
          {$? zerance.display_cart_count }}
          <div class="scz-cart-header__cart_count">
            <span class="scz-cart-header__cart_count-text">
              {$=zerance.cart_count}}
            </span>
          </div>
          {$?}}
          {$? "false" == "true" }}
          <div class="scz-cart-header__menu" scz-cart-menu>
            <svg class="scz-cart-svg scz-cart-menu-open" scz-cart-menu-open width="30" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="16.5" cy="7.09676" r="2.01924" fill="black"/>
              <circle cx="16.5" cy="16.4999" r="2.01924" fill="black"/>
              <circle cx="16.5" cy="25.9032" r="2.01924" fill="black"/>
            </svg>
            <svg scz-cart-menu-close class="scz-cart-menu-close" width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22.1707 0.829285L0.829224 22.1708" stroke="black" stroke-width="2"/>
              <path d="M22.1708 22.1708L0.829351 0.829284" stroke="black" stroke-width="2"/>
            </svg>
            <div>
              <ul class="scz-cart-header__menu-options">
                <li scz-cart-menu-share class="scz-cart-header__menu-option">{$=zerance.menu_share}}</li>
                <li scz-cart-menu-save class="scz-cart-header__menu-option">{$=zerance.menu_save}}</li>
                <li class="scz-cart-header__menu-option"><a href="{$=zerance.menu_contact_link}}">{$=zerance.menu_contact}}</a></li>
              </ul>
              
            </div>
          </div>
  
          {$?}}
        </div>
        
  
      </div>
  </template>
  
  <template id="scz-cart-icons">
    <div id="{$=zerance.id}}" class="scz-cart-icons">
      <div class="scz-cart-icons__grid scz-cart-icons__grid-{$=zerance.numberPerRow}} scz-cart-icons__grid-{$=zerance.align}}">
        {$~zerance.icons :value:index}}
          <div class="scz-cart-icon scz-cart-icon__direction-{$=value.grid_direction}}">
            <img src="{$=value.icon_url}}" class="scz-cart-icon__image scz-cart-icon__image-{$=value.icon_width}}" alt="{$=value.icon_text}}">
            <div class="">{$=value.icon_text}}</div>
          </div>
        {$~}}
      </div>
    </div>
  </template>
  
  <script id="scz-cart-image" type="template/x-dotjs">
      <div id="{$=zerance.id}}" class="scz-cart-image scz-cart-image--width-{$=zerance.width}} scz-cart-image--crop-{$=zerance.crop}}">
        {$? zerance.src }}
          <img class="scz-cart-image-content" src="{$=zerance.src}}">
        {$??}}
          <!-- no source is specified -->
        {$?}}
  </script>
  <script id="scz-cart-item_added_item" type="template/x-dotjs">
    {$? zerance.options.grouping.enabled }}
      {$? zerance.options.grouping.title }}
        <p class="scz-cart-item__grouping-title">{$=zerance.options.grouping.title}}</p>
      {$?}}
    {$?}}
    <div id="{$=zerance.id}}"
      {$#def.block_attributes}}
       scz-cart-item class="scz-cart-item__container">
      <div class="scz-cart-item__content">
        <div class="scz-cart-item">
  
          {$##def.image:
            <img class="scz-cart-item__image" src="{$=zerance.line_item.image}}" alt="{$=zerance.line_item.handle}}">
          #}}
  
          {$? zerance.options.link_product.image }}
            <a href="{$=zerance.line_item.url}}">
              {$#def.image}}
            </a>
          {$??}}
            <div class="scz-cart-item__image-container">
              {$#def.image}}
            </div>
          {$?}}
  
          <div class="scz-cart-item-info-container">
            <div class="scz-cart-item__info">
                {$? zerance.options.link_product.title }}
                  <a class="scz-cart-item__title" href="{$=zerance.line_item.url}}">
                    {$=zerance.line_item.product_title}}
                  </a>
                {$??}}
                  <div class="scz-cart-item__title">
                    {$=zerance.line_item.product_title}}
                  </div>
                {$?}}
  
                <div class="scz-cart-item__description">
                  {$? zerance.line_item.variant_title && zerance.line_item.variant_title != "Default Title" }}
                    {$=zerance.line_item.variant_title}}
                  {$?}}
                </div>
  
                <div class="">
                  {$=zerance.line_item.quantity}}
                </div>
            </div>
  
            {$? zerance.line_item.original_line_price }}
              <p class="scz-cart-item__original-price">
                {$=zerance.line_item.original_line_price | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}
              </p>
            {$?}}
  
            <div class="scz-cart-item__remove-container">
              <div scz-cart-remove-item_added-item class="scz-cart-item__remove scz-cart-item__remove-icon hide"></div>
            </div>
  
          </div>
        </div>
      </div>
  
      {$? zerance.options.remove.enable_swiping_on_mobile }}
        <div class="scz-cart-item__swipping-remove">
          {$#def.remove_template}}
        </div>
      {$?}}
    </div>
  </script>
  
  <script id="scz-cart-item_adder_item" type="template/x-dotjs">
    {$? zerance.options.grouping.enabled }}
      {$? zerance.options.grouping.title }}
        <p class="scz-cart-item__grouping-title">{$=zerance.options.grouping.title}}</p>
      {$?}}
    {$?}}
    <div id="{$=zerance.id}}"
      {$#def.block_attributes}}
       scz-cart-item class="scz-cart-item__container">
      <div class="scz-cart-item__content">
        <div class="scz-cart-item">
  
          {$##def.image:
            <img class="scz-cart-item__image" src="{$=zerance.line_item.image}}" alt="{$=zerance.line_item.handle}}">
          #}}
  
          {$? zerance.options.link_product.image }}
            <a href="{$=zerance.line_item.url}}">
              {$#def.image}}
            </a>
          {$??}}
            <div class="scz-cart-item__image-container">
              {$#def.image}}
            </div>
          {$?}}
  
          <div class="scz-cart-item-info-container">
            <div class="scz-cart-item__info">
                {$? zerance.options.link_product.title }}
                  <a class="scz-cart-item__title" href="{$=zerance.line_item.url}}">
                    {$=zerance.line_item.product_title}}
                  </a>
                {$??}}
                  <div class="scz-cart-item__title">
                    {$=zerance.line_item.product_title}}
                  </div>
                {$?}}
  
                <div class="scz-cart-item__description">
                  {$? zerance.line_item.variant_title && zerance.line_item.variant_title != "Default Title" }}
                    {$=zerance.line_item.variant_title}}
                  {$?}}
                </div>
  
                <div class="">
                  {$#def.quantity_template}}
                </div>
            </div>
  
            {$? zerance.line_item.original_line_price }}
              <p class="scz-cart-item__original-price">
                {$=zerance.line_item.original_line_price | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}
              </p>
            {$?}}
  
            <div class="scz-cart-item__remove-container">
              {$#def.remove_template}}
            </div>
  
            {$? zerance.options.item_adder && zerance.options.item_adder.enabled && zerance.line_item.tags }}
              <div class="scz-cart-item-adder-box">
                <div class="scz-cart-item-adder-box-content">
                  <div class="scz-cart-item-adder-box-checkbox">
                    
                    <label for="item_adder--{$=zerance.line_item.variant_id}}" class="scz-cart-note__label">
                      <div class="scz-cart-footer-checkbox-label">
                        {$=zerance.options.item_adder.label}}
                      </div>
                      <input scz-cart-item-adder class="scz-cart-footer-checkbox-input" scz-cart-item-adder-product-variant="{$=zerance.variantItemAdder.id}}" scz-cart-item-adder-input type="checkbox" name="item_adder--{$=zerance.line_item.variant_id}}" id="item_adder--{$=zerance.line_item.variant_id}}" {$? zerance.line_item.properties && zerance.line_item.properties.has_item_adder && zerance.line_item.properties.item_adder_variant_id != null }}checked="checked"{$?}}>
                      <span class="scz-cart-footer-checkbox-checkmark"></span>
                    </label>
  
                  </div>
                </div>
              </div>
            {$?}}
          </div>
        </div>
      </div>
  
      {$? zerance.options.remove.enable_swiping_on_mobile }}
        <div class="scz-cart-item__swipping-remove">
          {$#def.remove_template}}
        </div>
      {$?}}
    </div>
    </script>
  
  <script id="scz-cart-basic_item" type="template/x-dotjs">
    {$? zerance.options.grouping.enabled }}
      {$? zerance.options.grouping.title }}
        <p class="scz-cart-item__grouping-title">{$=zerance.options.grouping.title}}</p>
      {$?}}
    {$?}}
    <div id="{$=zerance.id}}"
      {$#def.block_attributes}}
       scz-cart-item class="scz-cart-item__container">
      <div class="scz-cart-item__content">
        <div class="scz-cart-item">
  
          {$##def.image:
            <img class="scz-cart-item__image" src="{$=zerance.line_item.image}}" alt="{$=zerance.line_item.handle}}">
          #}}
  
          {$? zerance.options.link_product.image }}
            <a href="{$=zerance.line_item.url}}">
              {$#def.image}}
            </a>
          {$??}}
            <div class="scz-cart-item__image-container">
              {$#def.image}}
            </div>
          {$?}}
  
          <div class="scz-cart-item-info-container">
            <div class="scz-cart-item__info">
                {$? zerance.options.link_product.title }}
                  <a class="scz-cart-item__title" href="{$=zerance.line_item.url}}">
                    {$=zerance.line_item.product_title}}
                  </a>
                {$??}}
                  <div class="scz-cart-item__title">
                    {$=zerance.line_item.product_title}}
                  </div>
                {$?}}
  
                <div class="scz-cart-item__description">
                  {$? zerance.line_item.variant_title && zerance.line_item.variant_title != "Default Title" }}
                    {$=zerance.line_item.variant_title}}
                  {$?}}
                </div>
  
                <div class="">
                  {$#def.quantity_template}}
                </div>
            </div>
  
            {$? zerance.line_item.original_line_price }}
              <p class="scz-cart-item__original-price">
                {$=zerance.line_item.original_line_price | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}
              </p>
            {$?}}
  
            <div class="scz-cart-item__remove-container">
              {$#def.remove_template}}
            </div>
  
            {$? zerance.options.popupActions.convertSubscription && zerance.options.popupActions.convertSubscription.enabled && zerance.line_item.metafields && (zerance.line_item.metafields.shipping_subscription_id != 227711 || zerance.line_item.title.toLowerCase().includes('vaisselle')) }}
              <div scz-cart-subscription-popup-trigger class="scz-cart-subscription-box">
                <div class="scz-cart-subscription-box-content">
                  <div class="scz-cart-subscription-box-checkbox">
                    <input type="checkbox" name="item_subscribed" id="item_subscribed">
                    <label for="item_subscribed"></label>
                  </div>
                  <span class="scz-cart-subscription-box-label pls">{$=zerance.options.popupActions.convertSubscription.label}}</span>
                </div>
                <div class="scz-cart-subscription-box-content">
                  {$? zerance.line_item.metafields }}
                  <span class="scz-cart-popup-subscription-product-price prs">{$=zerance.line_item.original_line_price * ((100 - zerance.line_item.metafields.discount_percentage) / 100) | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}</span>
                  {$?}}
                  <span class="scz-cart-popup-subscription-product-compare-price">{$=zerance.line_item.original_line_price | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}</span>
                </div>
              </div>
            {$?}}
          </div>
        </div>
      </div>
  
      {$? zerance.options.remove.enable_swiping_on_mobile }}
        <div class="scz-cart-item__swipping-remove">
          {$#def.remove_template}}
        </div>
      {$?}}
    </div>
    </script>
  
  <script id="scz-cart-featured_upsell_item" type="template/x-dotjs">
    {$? zerance.options.grouping.enabled }}
      {$? zerance.options.grouping.title }}
        <p class="scz-cart-item__grouping-title">{$=zerance.options.grouping.title}}</p>
      {$?}}
    {$?}}
    <div id="{$=zerance.id}}"
      {$#def.block_attributes}}
       scz-cart-item class="scz-cart-item__container">
      <div class="scz-cart-item__content">
        <div class="scz-cart-item">

          <div></div>
  
          {$##def.image:
            <img class="scz-cart-item__image" src="{$=zerance.line_item.image}}" alt="{$=zerance.line_item.handle}}">
          #}}
  
          {$? zerance.options.link_product.image }}
            <a href="{$=zerance.line_item.url}}">
              {$#def.image}}
            </a>
          {$??}}
            <div class="scz-cart-item__image-container">
              {$#def.image}}
            </div>
          {$?}}
  
          <div class="scz-cart-item-info-container">
            
            <div class="scz-cart-item__info">
                <div>
                  {$? zerance.options.link_product.title }}
                    <a class="scz-cart-item__title" href="{$=zerance.line_item.url}}">
                      {$=zerance.line_item.product_title}}
                    </a>
                  {$??}}
                    <div class="scz-cart-item__title">
                      {$=zerance.line_item.product_title}}
                    </div>
                  {$?}}
  
                  <div class="scz-cart-item__description">
                    {$? zerance.line_item.variant_title && zerance.line_item.variant_title != "Default Title" }}
                      {$=zerance.line_item.variant_title}}
                    {$?}}
                  </div>
                </div>
  
                <div class="scz-cart-item__info-row">

                  {$#def.quantity_template}}

                  <div class="scz-cart-item__prices-wrap">

                    {$? zerance.line_item.compare_at_price && (zerance.line_item.compare_at_price * zerance.line_item.quantity) > zerance.line_item.original_line_price }}
                      <p class="scz-cart-item__compare-price">
                        {$=(zerance.line_item.compare_at_price * zerance.line_item.quantity) | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}
                      </p>
                    {$??}}
                      {$? zerance.line_item.original_line_price && zerance.line_item.original_line_price > zerance.line_item.final_line_price }}
                        <p class="scz-cart-item__compare-price">
                          {$=zerance.line_item.original_line_price | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}
                        </p>
                      {$?}}
                    {$?}}

                    {$? zerance.line_item.final_line_price }}
                      <p class="scz-cart-item__original-price">
                        {$=zerance.line_item.final_line_price | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}
                      </p>
                    {$?}}

                  </div>

                </div>
            </div>
  
          </div>
        </div>
      </div>
    </div>
    </script>
  
  <script id="scz-cart-reward_item" type="template/x-dotjs">
    {$? zerance.options.grouping.enabled }}
      {$? zerance.options.grouping.title }}
        <p class="scz-cart-item__grouping-title">{$=zerance.options.grouping.title}}</p>
      {$?}}
    {$?}}
    <div id="{$=zerance.id}}"
      {$#def.block_attributes}}
       scz-cart-item class="scz-cart-item__container scz-cart-reward_item">
      <div class="scz-cart-item__content">
        <div class="scz-cart-item">

          <div class="scz-cart-item__remove-container">
            <div scz-cart-remove-reward-item class="scz-cart-item__remove scz-cart-item__remove-icon">
              <div scz-cart-item-quantity-action="0" class="scz-cart-item__remove scz-cart-item__remove-icon"> 
                <img src="https://cdn.shopify.com/s/files/1/0562/8575/7497/files/close_black_24dp.svg?v=1649090633" alt="Delete">
              </div>
            </div>
          </div>
  
          {$##def.image:
            <img class="scz-cart-item__image" src="{$=zerance.line_item.image}}" alt="{$=zerance.line_item.handle}}">
          #}}
  
          {$? zerance.options.link_product.image }}	
            <a class="scz-cart-item__image-container" href="{$=zerance.line_item.url}}">	
              {$#def.image}}	
            </a>	
          {$??}}	
            <div class="scz-cart-item__image-container">	
              {$#def.image}}	
            </div>	
          {$?}}
  
          <div class="scz-cart-item-info-container">
            <div class="scz-cart-item__info">
              <div>	
                {$? zerance.options.link_product.title }}	
                  <a class="scz-cart-item__title" href="{$=zerance.line_item.url}}">	
                    {$=zerance.line_item.product_title}}	
                  </a>	
                {$??}}	
                  <div class="scz-cart-item__title">	
                    {$=zerance.line_item.product_title}}	
                  </div>	
                {$?}}	

                <div class="scz-cart-item__description">	
                  {$? zerance.line_item.variant_title && zerance.line_item.variant_title != "Default Title" }}	
                    {$=zerance.line_item.variant_title}}	
                  {$?}}	
                </div>
              </div>

            </div>
  
            <div class="scz-cart-item__info-row">	
              <div></div>
              <div class="scz-cart-item__prices-wrap">
                {$? zerance.line_item.original_line_price }}	
                  <p class="scz-cart-item__original-price">	
                    OFFERT
                  </p>	
                {$?}}	
              </div>	
            </div>

          </div>
        </div>
      </div>
  
      {$? zerance.options.remove.enable_swiping_on_mobile }}
        <div class="scz-cart-item__swipping-remove">
          {$#def.remove_template}}
        </div>
      {$?}}
    </div>
  </script>
  
  <template id="scz-cart-items">
      <div id="{$=zerance.id}}" class="scz-cart-content">
        <div scz-cart-items class="scz-cart-items scz-cart-items-remove_template-{$=zerance.remove_template}}">
          {$=zerance.items_html}}
        </div>
      </div>
  </template>
  
  <script id="scz-cart-note" type="template/x-dotjs">
      <div id="{$=zerance.id}}" scz-cart-note class="scz-cart-note">
  
        <div class="scz-cart-note__wrapper">
  
          {$? zerance.style == 'collapse' }}
            {$? zerance.title }}
              <label for="note_collapse" class="scz-cart-note__label">
                <div class="scz-cart-featured_upsell__label-flex">
                  <p>{$=zerance.title}}</p>
                  {$? zerance.subtitle }}
                    <span class="scz-cart-featured_upsell__label-tooltip">
                      <div class="scz-cart-featured_upsell__label-tooltip-text">?</div>
                      <div class="scz-cart-featured_upsell__description">{$=zerance.subtitle}}</div>
                    </span>
                  {$?}}
                </div>
                <input type="checkbox" id="note_collapse" scz-cart__note-collapse-toggle name="note_collapse" class="scz-cart-note__input" {$=zerance.input_attr}} {$? zerance.cart.note && zerance.cart.note.length }}checked="checked"{$?}}>
                <span class="scz-cart-note__checkmark"></span>
              </label>
            {$?}}
  
          {$?? zerance.style == 'slide'}}
  
            <label for="note_slide" class="scz-cart-note__label">
              <div class="scz-cart-featured_upsell__label-flex">
                <p>{$=zerance.title}}</p>
                {$? zerance.subtitle }}
                  <span class="scz-cart-featured_upsell__label-tooltip">
                    <div class="scz-cart-featured_upsell__label-tooltip-text">?</div>
                    <div class="scz-cart-featured_upsell__description">{$=zerance.subtitle}}</div>
                  </span>
                {$?}}
              </div>
              <input type="checkbox" id="note_slide" scz-cart__note-slide-toggle name="note_slide" class="scz-cart-note__input" {$=zerance.input_attr}} {$? zerance.cart.note && zerance.cart.note.length }}checked="checked"{$?}}>
              <span class="scz-cart-note__checkmark"></span>
            </label>
            <div scz-cart__note-slide-open class="scz-cart-note__edit {$? zerance.cart.note && zerance.cart.note.length }}scz-cart-note--active{$?}}">Modifier</div>
          
          {$??}}
            {$? zerance.title }}
              <h2 class="scz-cart-note__title">
                  {$=zerance.title}}
              </h2>
            {$?}}
            {$? zerance.subtitle }}
              <p class="scz-cart-note__subtitle">
                  {$=zerance.subtitle}}
              </p>
            {$?}}
          {$?}}
  
          <div {$? zerance.style == 'collapse' }}scz-cart__note-collapse-container{$?}} {$? zerance.style == 'slide' }}scz-cart__note-slide-container{$?}} class="scz-cart-note__wrap-message {$? zerance.style == 'collapse' }}scz-cart-note-collapse {$? zerance.cart.note && zerance.cart.note.length }}scz-cart-note--active{$?}} {$?}} {$? zerance.style == 'slide' }}scz-cart-note-slide{$?}} {$? zerance.style == 'block' }}scz-cart-note-block{$?}} ">
            {$? zerance.style == 'slide' }}
  
              <div class="scz-cart-note-slide--container">
  
              <div class="scz-cart-note-slide_header">
                <div class="scz-cart-note-slide_close" scz-cart__note-slide-close>
                  <svg class="scz-cart-svg" width="14" height="23" viewBox="0 0 14 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.8079 0.884094L2.19202 11.5L12.8079 22.1159" stroke="black" stroke-width="2"/>
                  </svg>
                </div>
              </div>
              {$? zerance.style == 'slide' }}
                <div class="scz-cart-note-slide_container">
              {$?}}
  
              {$? zerance.image_slide }}
                <div class="scz-cart-note-slide_banner--container">
                  <img src="{$=zerance.image_slide}}" alt="{$=zerance.title_slide}}" class="scz-cart-note-slide_banner">
                </div>
              {$?}}
  
              {$? zerance.title_slide }}
                <p class="scz-cart-note-slide_title">{$=zerance.title_slide}}</p>
              {$?}}
              {$? zerance.subtitle_slide }}
                <p class="scz-cart-note-slide_subtitle">{$=zerance.subtitle_slide}}</p>
              {$?}}
            {$?}}
  
            <textarea class="scz-cart-note__message" rows="3" {$? zerance.placeholder }}placeholder="{$=zerance.placeholder}}"{$?}}
            scz-cart__note-input
            {$? zerance.max_chars && !isNaN(zerance.max_chars) }}
                maxlength="{$=zerance.max_chars}}"
            {$??}}{$?}}
            >{$? zerance.cart.attributes.MessagePerso != null }}{$=zerance.cart.attributes.MessagePerso}}{$?}}</textarea>
  
            <p class="scz-cart-note__char-remaining">
              <span scz-cart__note-remaining-chars-count class="scz-cart-featured_upsell__char-count">
                {$? zerance.cart.note && zerance.cart.note.length }}
                  {$= zerance.max_chars - zerance.cart.note.length }}
                {$??}}
                  {$=zerance.max_chars}}
                {$?}}
              </span>
              caractères restants
            </p>
  
            {$? zerance.style == 'slide' }}
              {$? zerance.buton_slide }}
                <div class="scz-cart-note-slide_button" scz-cart__note-slide-close>{$=zerance.buton_slide}}</div>
              {$?}}
              </div>
            {$?}}
  
            {$? zerance.style == 'slide' }}
              </div>
            {$?}}
  
  
          </div>
  
        </div>
  
      </div>
    </script>
  
  <script id="scz-cart-popup" type="template/x-dotjs">
      <div id="scz-cart-popup" scz-cart-popup class="scz-cart-popup">
        <div class="scz-cart-popup-overlay"></div>
        <div class="scz-cart-popup-container">
          <div scz-cart-popup-close class="scz-cart-popup-close">
            <img class="scz-cart-svg" src="https://cdn.shopify.com/s/files/1/0562/8575/7497/files/close_black_24dp.svg?v=1649090633" alt="Delete">
          </div>
          <div scz-cart-popup-content>
            <div class="scz-cart-popup-content">
              <div class="scz-cart-popup-content-header">
                <div class="scz-cart-popup-content-images">
                  <div class="scz-cart-popup-content-image-overlay"></div>
                  <img class="scz-cart-popup-content-image" src="{$=zerance.item.featured_image}}" alt="">
                </div>
              </div>
  
              <div class="scz-cart-popup-content-footer">
                {$? zerance.item.metafields && zerance.settings.frequency && zerance.settings.frequency.display }}
                  <div class="scz-cart-popup-content-selects">
                    <div class="scz-cart-popup-content-flex scz-cart-popup-content-select">
                      <label for="item_frequency">Fréquence</label>
                      <select class="" scz-cart-popup-subscription-frequency name="item_frequency">
                        {$~ zerance.item.metafields.shipping_interval_frequency:value}}
                          <option
                          {$? zerance.form_type == 'updateNonNativeRecharge' }}
                            {$? value == zerance.item.properties.shipping_interval_frequency }}selected{$?}}
                          {$??}}
                            {$? value == zerance.settings.frequency.default }}selected{$?}}
                          {$?}}
                           value='{"shipping_interval_frequency": "{$=value}}", "shipping_interval_unit_type": "{$=zerance.item.metafields.shipping_interval_unit_type}}", "subscription_id": "{$=zerance.item.metafields.shipping_subscription_id}}"}'>Tous les {$=value}} {$=zerance.item.metafields.shipping_interval_unit_type | __ascf.dateUnitFormatter: zerance.item.metafields.shipping_interval_unit_type }}</option>
                        {$~}}
                      </select>
                    </div>
                  </div>
                {$?}}
  
                <div class="scz-cart-popup-content-product-info {$? zerance.item.metafields && zerance.form_type == 'replace' }}scz-cart-popup-content-product-info-subscription{$?}} {$? zerance.item.metafields && zerance.form_type == 'updateNonNativeRecharge' }}scz-cart-popup-content-product-info-subscription{$?}}">
                    <p class="scz-cart-popup-content-product-title">{$=zerance.item.title}}</p>
  
                    {$? zerance.item.variants.length > 0 }}
  
                    {$? !zerance.settings.enable_variants }}
                      {$=zerance.item.variant_title}}
                    {$?}}
  
                      <div class="scz-cart-popup-options {$? !zerance.settings.enable_variants }}scz-cart-popup-hide{$?}}">
                        {$~ zerance.item.variants_options:option:index}}
                          <div class="scz-cart-popup-option">
                            <label for="SingleOptionSelector-{$= index}}" class="scz-cart-popup-content-product-variant-title">
                              {$= option.name }}
                            </label>
                            <select scz-cart-popup-product-single-option class="scz-cart-popup-option--select"
                              id="SingleOptionSelector-{$= index}}"
                              data-index="option{$= index}}"
                            >
                            {$~ option.values:value }}
                              <option value="{$= value }}"{$? zerance.selected_variant_options[index] == value}} selected="selected"{$?}}>{$= value }}</option>
                            {$~}}
                            </select>
                          </div>
                        {$~}}
                      </div>
  
                    <select class="scz-cart-popup-hide" scz-cart-popup-product-variant>
                      {$~ zerance.item.variants:value}}
                        <option {$? zerance.selected_variant == value.id}} selected {$?}} value='{$=value.id}}'>{$=value.title}}</option>
                      {$~}}
                    </select>
                    {$?}}
  
  
                </div>
  
                {$? zerance.form_type == 'replace' }}
                  <div class="scz-cart-popup-content-marketing">
                    <div class="scz-cart-popup-content-marketing__title">
                      L'abonnement c'est :
                    </div>
  
                    <div class="scz-cart-popup-content-marketing__content">
                      <ul>
                        <li>+ économique</li>
                        <li>Ajustable facilement</li>
                        <li>Sans engagement</li>
                        <li>Livré tous les 2 mois</li>
                      </ul>
                    </div>
                  </div>
                {$?}}
  
                <div class="scz-cart-popup-content-flex scz-cart-popup-content-footer-container">
                  <div class="scz-cart-item__quantity-container">
                    <p class="scz-cart-item__quantity-label">Quantité :</p>
                    <div scz-cart-popup-item-quantity-container class="scz-cart-item__quantity-wrapper {$? !zerance.settings.enable_quantity }}scz-cart-popup-hide{$?}}">
                      <span scz-cart-popup-item-quantity-decrease class="scz-cart-item__quantity scz-cart-item__quantity-decrement">–</span>
                      <input type="number" name="item_quantity" scz-cart-popup-item-quantity value="{$=zerance.item.quantity.value}}" class="scz-cart-item__quantity-number"></span>
                      <span scz-cart-popup-item-quantity-increase class="scz-cart-item__quantity scz-cart-item__quantity-increment">+</span>
                    </div>
                  </div>
  
                  <div class="">
                    {$? zerance.item.metafields && zerance.form_type == 'replace' }}
                      <p class="scz-cart-popup-content-product-price" szc-popup-original-price="{$=zerance.item.original_line_price}}" szc-popup-discount-percentage="{$=zerance.item.metafields.discount_percentage}}" szc-popup-subscription-price>{$= zerance.item.quantity.value * (zerance.item.original_line_price * ((100 - zerance.item.metafields.discount_percentage) / 100)) | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}</p>
                      <p class="scz-cart-popup-content-product-compare-price" szc-popup-no-subscription-price>{$= (zerance.item.quantity.value *zerance.item.original_line_price) | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}</p>
                    {$??}}
                      <p class="scz-cart-popup-content-product-price" szc-popup-unit-price="{$=zerance.item.original_line_price}}">{$= (zerance.item.quantity.value * zerance.item.original_line_price) | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}</p>
                      <p class="scz-cart-popup-content-product-compare-price {$? zerance.item.compare_at_price }}scz-cart-popup-content-product-compare-price--active{$?}}" szc-popup-compare-price="{$=zerance.item.compare_at_price}}">{$= (zerance.item.quantity.value * zerance.item.compare_at_price) | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}</p>
                    {$?}}
                  </div>
  
                </div>
              </div>
            </div>
          </div>
          {$? zerance.settings.popup_submit_label }}
            <div class="scz-cart-popup-content-submit-container">
              <div scz-cart-popup-submit class="scz-cart-popup-submit">
                <span scz-cart-popup-submit-label class="scz-cart-popup-submit__label">{$=zerance.settings.popup_submit_label}}</span>
                <span scz-cart-popup-submit-loader class="scz-cart-popup-submit__loader"><div class="scz-cart-loader"><div></div><div></div><div></div><div></div></div></span>
              </div>
            </div>
          {$?}}
        </div>
      </div>
  </script>
  
  <script id="scz-cart-rewards" type="template/x-dotjs">
    <div id="{$=zerance.id}}" scz-cart-rewards class="scz-cart-rewards scz-cart-rewards-style--{$=zerance.progress_style}}">
  
      {$? zerance.progress_style == "balanced" || zerance.progress_style == "exact" || zerance.progress_style == "balanced_without_progress_bar" || zerance.progress_style == "balanced_with_center_progress_bar" }}
        <div class="scz-cart-rewards__message" scz-cart-rewards--current-message>{$=zerance.next_message}}</div>
        <div class="scz-cart-rewards__message" scz-cart-rewards--next-message>{$=zerance.current_message}}</div>
  
        <div class="scz-cart-reward-progress-bar-container">
          {$~zerance.rewards :value:index}}
            <div class="scz-cart-reward-progress-reward" style="left: {$=value.position_percentage}}%;">
              {$? zerance.progress_style == "balanced_without_progress_bar" || zerance.progress_style == "balanced_with_center_progress_bar" }}
              <p class="scz-cart-reward-progress-reward__price">{$=value.threshold  | __ascf.formatMoney: zerance.money_formats.with_comma_separator }}</p>
              {$?}}
              <img class="scz-cart-reward-progress-reward__image" src="{$=value.image}}">
              <div class="scz-cart-reward-progress-reward__pin"></div>
              {$? zerance.progress_style == "balanced" || zerance.progress_style == "exact" }}
              <p class="scz-cart-reward-progress-reward__price">{$=value.threshold  | __ascf.formatMoney: zerance.money_formats.with_comma_separator }}</p>
              {$?}}
              <p class="scz-cart-reward-progress-reward__title">{$=value.title}}</p>
              {$? zerance.progress_style == "balanced_without_progress_bar" }}
              <div class="scz-cart-reward-progress-reward__arrow">
                <svg width="59" height="8" viewBox="0 0 59 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M57.9872 4.33915C58.1825 4.14389 58.1825 3.8273 57.9872 3.63204L54.8053 0.450062C54.61 0.2548 54.2934 0.2548 54.0981 0.450062C53.9029 0.645324 53.9029 0.961906 54.0981 1.15717L56.9266 3.9856L54.0981 6.81402C53.9029 7.00928 53.9029 7.32587 54.0981 7.52113C54.2934 7.71639 54.61 7.71639 54.8053 7.52113L57.9872 4.33915ZM0.914062 4.4856H57.6337V3.4856H0.914062V4.4856Z" fill="black"/>
                </svg>
              </div>
              {$?}}
            </div>
          {$~}}
          <div scz-cart-rewards--progress-bar style="width:{$=zerance.progress_percentage}}%" class="scz-cart-reward-progress-bar"></div>
        </div>
      {$?}}
  
      {$? zerance.progress_style == "separate_from_zero" }}
        {$~zerance.rewards :value:index}}
          <div class="scz-cart-rewards__container">
            <div class="scz-cart-rewards__wrap-content">
              <img class="scz-cart-reward__image" src="{$=value.image}}">
              <div>
                <div class="scz-cart-rewards__message" scz-cart-rewards--current-message>{$=zerance.next_message}}</div>
                <div class="scz-cart-rewards__message" scz-cart-rewards--next-message>{$=zerance.current_message}}</div>
              </div>
            </div>
            <div class="scz-cart-reward-progress-bar-container">
              <div scz-cart-rewards--progress-bar style="width:{$=zerance.progress_percentage}}%" class="scz-cart-reward-progress-bar"></div>
            </div>
          </div>
        {$~}}
      {$?}}
  
  
      {$? zerance.progress_style == "separate_from_last_reward" }}
  
        {$~zerance.rewards :value:index}}
          {$? index == 0 }}
            <div class="scz-cart-rewards__container">
              <div class="scz-cart-rewards__wrap-content">
                <img class="scz-cart-reward__image" scz-cart-rewards--current-image src="{$=value.image}}">
                <div>
                  <div class="scz-cart-rewards__message" scz-cart-rewards--current-message>{$=zerance.next_message}}</div>
                  <div class="scz-cart-rewards__message" scz-cart-rewards--next-message>{$=zerance.current_message}}</div>
                </div>
              </div>
            {$?}}
          {$~}}
  
          <div class="scz-cart-reward-progress-bar-container">
            <div scz-cart-rewards--progress-bar style="width:{$=zerance.progress_percentage}}%" class="scz-cart-reward-progress-bar"></div>
          </div>
        </div>
      {$?}}
  
    </div>
  </script>
  
  <template id="scz-cart-richtext">
      <div id="{$=zerance.id}}" scz-cart-richtext class="scz-cart-richtext scz-cart-richtext-{$=zerance.settings.configurations.content_alignment}}">
        <p class="scz-cart-richtext__title scz-cart-richtext__title-{$=zerance.settings.configurations.font_title}}">{$=zerance.settings.configurations.title}}</p>
        <div class="scz-cart-richtext__description scz-cart-richtext__description-{$=zerance.settings.configurations.font_description}}">{$=zerance.settings.configurations.description}}</div>
      </div>
  </template>
  
  <script id="scz-cart-slider" type="template/x-dotjs">
    <div id="{$=zerance.id}}" class="scz-cart-slider scz-cart-slider-active_arrows-{$=zerance.active_arrows}} scz-cart-slider-active_dots-{$=zerance.active_dots}}">
  
      {$? zerance.slides.length > 0 }}
        {$? zerance.title }}
          <p class="">
              {$=zerance.title}}
          </p>
        {$?}}
  
        <div class="glider-contain">
          <div class="glider" scz-cart__slider>
            {$~zerance.slides :slide:index}}
              <div class="scz-cart-slider__item">
                {$? slide.image }}
                  <img src="{$=slide.image}}" class="scz-cart-slider__item-img">
                {$?}}
                {$? slide.title }}
                  <p class="scz-cart-slider__item-title">
                    {$=slide.title}}
                  </p>
                {$?}}
                {$? slide.description }}
                  <p class="scz-cart-slider__item-description">
                    {$=slide.description}}
                  </p>
                {$?}}
              </div>
            {$~}}
          </div>
  
          <button aria-label="Previous" scz-cart__slider__prev class="glider-prev">
            <svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.49989 1.18109L1 8.68098L8.49992 16.1809" stroke="black" stroke-width="1.27273"/>
            </svg>
          </button>
          <button aria-label="Next" scz-cart__slider__next class="glider-next">
            <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.886647 1.18109L8.38654 8.68098L0.88662 16.1809" stroke="black" stroke-width="1.27273"/>
            </svg>
          </button>
          <div role="tablist" scz-cart__slider__dots class="dots"></div>
        </div>
      {$?}}
    </div>
  </script>
  
  <template id="scz-cart-spacer">
      <div id="{$=zerance.id}}" class="scz-cart-spacer scz-cart-spacer-{$=zerance.spacing}}">
  
      </div>
  </template>
  
  <template id="scz-cart-summary">
      <div id="{$=zerance.id}}" scz-cart-summary class="scz-cart-summary">
        {$? zerance.summary }}
        <div>
          {$? zerance.summary.title }}
            {$? zerance.summary.title.isCollapsible }}
            <input class="scz-cart-summary__checkbox" id="scz-cart-summary-collapse-{$=zerance.id}}" type="checkbox" checked="{$? zerance.summary.title.isOpenDefault }}checked{$?}}">
            <label for="scz-cart-summary-collapse-{$=zerance.id}}" class="scz-cart-summary__title-collapsible">
              {$?}}
              <span class="scz-cart-summary__title">{$=zerance.summary.title.label}}</span>
  
              {$? zerance.summary.title.isCollapsible }}
              <span class="scz-cart-summary__collapse"></span>
              {$?}}
              {$? zerance.summary.title.isCollapsible }}
              </label>
            {$?}}
            {$? zerance.summary.title.isCollapsible }}
            <div class="scz-cart-summary-content {$? zerance.summary.isOpenDefault == false }}scz-cart-summary-content--closed{$?}}">
              {$?}}
          {$?}}
              {$? zerance.summary.subtotal }}
                <div class="scz-cart-summary__row">
                  <span class="scz-cart-summary__subtitle">{$=zerance.summary.subtotal.label}}</span> <span class="scz-cart-summary__content">{$=zerance.summary.subtotal.value | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}</span>
                </div>
              {$?}}
  
              {$? zerance.summary.total }}
                <span class="scz-cart-summary__subtitle">{$=zerance.summary.total.label}}</span> <span class="scz-cart-summary__content">{$=zerance.summary.total.value | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}</span>
                <br>
              {$?}}
  
              {$? zerance.summary.discounts }}
                <span class="scz-cart-summary__subtitle">{$=zerance.summary.discounts.label}}</span> <span class="scz-cart-summary__content">{$=zerance.summary.discounts.value | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}</span>
                <br>
              {$?}}
  
              {$? zerance.summary.shipping }}
                <span class="scz-cart-summary__subtitle">{$=zerance.summary.shipping.label}}</span>
                {$? zerance.summary.shipping.enabled_estimate_shipping }}
                  <span class="scz-cart-summary__content" scz-estimate-shipping-price>{$=zerance.summary.shipping.value | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}</span>
                  <div class="scz-cart-summary__shipping_estimate--container" scz-estimate-shipping-container>
                    <div class="scz-cart-summary__shipping_estimate">
                      <p class="scz-cart-summary__shipping_estimate--country" scz-estimate-shipping-country-selected>Livraison en <span scz-estimate-shipping-price-country></span></p>
                      <div scz-estimate-shipping-selects-container>
  
                      </div>
                    </div>
                    <div class="scz-cart-summary__shipping_estimate">
                      <div class="scz-cart-summary__shipping_estimate--update hide" scz-estimate-shipping-update >{$=zerance.summary.shipping.enabled_estimate_shipping_label}}</div>
                      <div class="scz-cart-summary__shipping_estimate--confirm" scz-estimate-shipping-confirm>{$=zerance.summary.shipping.enabled_estimate_shipping_label_button}}</div>
                    </div>
                  </div>
                {$??}}
                  <span class="scz-cart-summary__content">{$=zerance.summary.shipping.value | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}</span>
                {$?}}
                <br>
              {$?}}
  
              {$? zerance.summary.weight }}
                <span class="scz-cart-summary__subtitle">{$=zerance.summary.weight.label}}</span> <span class="scz-cart-summary__content">{$=zerance.summary.weight.value}}</span>
                <br>
              {$?}}
  
              {$? zerance.summary.description }}
                <p class="scz-cart-summary__total--description">{$=zerance.summary.description.label}}</p>
              {$?}}
  
            {$? zerance.summary.title }}
              {$? zerance.summary.title.isCollapsible }}
            </div>
            {$?}}
          {$?}}
        </div>
        {$?}}
      </div>
  </template>
  
  <script id="scz-cart-upsell" type="template/x-dotjs">
    <div id="{$=zerance.id}}" class="scz-cart-upsell scz-cart-upsell-style-{$=zerance.style}}">
  
      {$? zerance.products.length > 0 }}
        {$? zerance.title }}
          <p class="scz-cart-upsell__title">
              {$=zerance.title}}
          </p>
        {$?}}
  
        {$? zerance.is_slider }}
          <div class="glider-contain">
            <div class="glider" scz-cart-upsell__slider>
              {$~zerance.products :product:index}}
                <div class="scz-cart-upsell__item">
                  {$? product.images[0] && product.images[0].src }}
                    <a class="scz-cart-upsell__item-wrap-img" href="/products/{$=product.handle}}">
                      <img src="{$=product.images[0].src}}" class="scz-cart-upsell__item-img">
                    </a>
                  {$??}}
                    <div></div>
                  {$?}}
                  <div class="scz-cart-upsell__item-infos">
                    <a href="/products/{$=product.handle}}">
                      <div class="scz-cart-upsell__item-titles">
                        <p class="scz-cart-upsell__item-title">
                          {$=product.title}}
                        </p>
                        {$? product.variants.length == 1 && product.variants[0].title != undefined }}
                          <p class="scz-cart-upsell__item-variant">{$=product.variants[0].title}}</p>
                        {$?}}
                      </div>
                    </a>

                    <div class="scz-cart-upsell__prices-wrap">

                      {$? product.variants[0].compare_at_price && product.variants[0].compare_at_price > product.variants[0].price }}
                        <p class="scz-cart-upsell__compare-price">
                          {$=product.variants[0].compare_at_price | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}
                        </p>
                      {$?}}

                      <p class="scz-cart-upsell__item-price">{$=product.variants[0].price | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}</p>

                    </div>
  
                    {$? product.variants.length > 1 }}
                      {$? zerance.popupActions.addProduct && zerance.popupActions.addProduct.enabled }}
                        <div scz-cart-popup-trigger-add scz-cart-popup-product-handle="{$=product.handle}}" class="scz-cart-upsell__item-btn">Ajouter</div>
                      {$??}}
                        <a class="scz-cart-upsell__item-btn" href="/products/{$=product.handle}}">En savoir plus</a>
                      {$?}}
                    {$??}}
                      <form method="post" action="/cart/add" id="product_form_{$=product.variants[0].id}}" accept-charset="UTF-8" enctype="multipart/form-data" novalidate="novalidate" data-product-form>
                        <input type="hidden" name="id" value="{$=product.variants[0].id}}">
                        <input type="hidden" name="form_type" value="product">
                        <input type="hidden" name="utf8" value="✓">
  
                        <button type="submit" name="add" class="scz-cart-upsell__item-btn" data-add-to-cart="">
                          <span>Ajouter</span>
                          /*
                          <span class="scz-cart-upsell__item-btn-price">{$=product.variants[0].price | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}</span>
                          */
                        </button>
                      </form>
                    {$?}}
                  </div>
                </div>
              {$~}}
            </div>
            <button aria-label="Previous" scz-cart-upsell__slider__prev class="glider-prev">
              <svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.49989 1.18109L1 8.68098L8.49992 16.1809" stroke="black" stroke-width="1.27273"/>
              </svg>
            </button>
            <button aria-label="Next" scz-cart-upsell__slider__next class="glider-next">
              <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.886647 1.18109L8.38654 8.68098L0.88662 16.1809" stroke="black" stroke-width="1.27273"/>
              </svg>
            </button>
          </div>
        {$??}}
          <div class="scz-cart-upsell__wrap-items {$? zerance.products_per_row }} scz-cart-upsell__{$=zerance.products_per_row}}-per-row {$?}}">
            {$~zerance.products :product:index}}
              <div class="scz-cart-upsell__item">
                {$? product.images[0] && product.images[0].src }}
                  <img src="{$=product.images[0].src}}" class="scz-cart-upsell__item-img">
                {$??}}
                  <div></div>
                {$?}}
                <div class="scz-cart-upsell__item-infos">

                  <a href="/products/{$=product.handle}}">
                    <div class="scz-cart-upsell__item-titles">
                      <p class="scz-cart-upsell__item-title">
                        {$=product.title}}
                      </p>
                      {$? product.variants.length == 1 && product.variants[0].title != undefined }}
                        <p class="scz-cart-upsell__item-variant">{$=product.variants[0].title}}</p>
                      {$?}}
                    </div>
                  </a>

                  <div class="scz-cart-upsell__prices-wrap">

                    {$? product.variants[0].compare_at_price && product.variants[0].compare_at_price > product.variants[0].price }}
                      <p class="scz-cart-upsell__compare-price">
                        {$=product.variants[0].compare_at_price | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}
                      </p>
                    {$?}}

                    <p class="scz-cart-upsell__item-price">{$=product.variants[0].price | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}</p>

                  </div>

                  {$? product.variants.length > 1 }}
                    {$? zerance.popupActions.addProduct && zerance.popupActions.addProduct.enabled }}
                      <div scz-cart-popup-trigger-add scz-cart-popup-product-handle="{$=product.handle}}" class="scz-cart-upsell__item-btn">Ajouter</div>
                    {$??}}
                      <a class="scz-cart-upsell__item-btn" href="/products/{$=product.handle}}">En savoir plus</a>
                    {$?}}
                  {$??}}
                    <form method="post" action="/cart/add" id="product_form_{$=product.variants[0].id}}" accept-charset="UTF-8" enctype="multipart/form-data" novalidate="novalidate" data-product-form>
                      <input type="hidden" name="id" value="{$=product.variants[0].id}}">
                      <input type="hidden" name="form_type" value="product">
                      <input type="hidden" name="utf8" value="✓">

                      <button type="submit" name="add" class="scz-cart-upsell__item-btn" data-add-to-cart="">
                        <span>Ajouter</span>
                        /*
                        <span class="scz-cart-upsell__item-btn-price">{$=product.variants[0].price | __ascf.formatMoney: zerance.money_formats.with_comma_separator}}</span>
                        */
                      </button>
                    </form>
                  {$?}}
  
                </div>
              </div>
            {$~}}
          </div>
        {$?}}
      {$?}}
    </div>
  </script>
  
  <script id="scz-cart-items_group" type="template/x-dotjs"> 
      <div class="scz-cart-items-group" data-group-type="{$=zerance.group_name}}">
          {$? zerance.title || zerance.subtitle }}
              <div class="scz-cart-items-group__header">
                  {$? zerance.title }}
                      <p class="scz-cart-items-group-title">{$=zerance.title}}</p>
                  {$?}}
                  {$? zerance.subtitle }}
                      <p class="scz-cart-items-group-title">{$=zerance.subtitle}}</p>
                  {$?}}
              </div>
          {$?}}
  
          <div class="scz-cart-items-group__content">
              {$=zerance.content}}
          </div>
  
          {$? zerance.footer }}
              <div class="scz-cart-items-group__footer">
                  {$=zerance.footer}}
              </div>
          {$?}}
      </div>
  </script>
  <template id="scz-cart-item">
      <div id="{$=zerance.id}}">
        <form scz-modify-form>
          {$~zerance.product.options :option:index}}
              {$=option.name}}
  
              <select class="">
                  {$~option.values :value:index}}
                      <option value="{$=value}}">{$=value}}</option>
                  {$~}}
              </select>
  
              <br>
          {$~}}
  
          
        </form>
      </div>
  </template>
  <template id="scz-cart-item-quantity-actions">
      <div class="scz-cart-item__quantity-wrapper">
          {$? zerance.options.quantity.updatable }}
            <span scz-cart-item-quantity-action="-" class="scz-cart-item__quantity scz-cart-item__quantity-decrement {$? zerance.line_item.quantity <= 1 }} disable {$?}}">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus"><title>Moins</title><line x1="5" y1="12" x2="19" y2="12"></line></svg>
            </span>
            <span class="scz-cart-item__quantity-number">{$=zerance.line_item.quantity}}</span>
            <span scz-cart-item-quantity-action="+" class="scz-cart-item__quantity scz-cart-item__quantity-increment">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus"><title>Plus</title><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
            </span>
          {$??}}
            /*
            <span class="scz-cart-item__quantity-number scz-cart-item__quantity-number-remove">{$=zerance.line_item.quantity}}</span>
            <span scz-cart-item-quantity-action="0" class="scz-cart-item__quantity scz-cart-item__quantity-remove">
              <span class="scz-cart-item__quantity-remove-icon">+</span>
            </span>
            */
          {$?}}
      </div>
  </template>
  
  <script id="scz-cart-item-quantity-dropdown" type="template/x-dotjs">
      <div class="scz-cart-item__quantity-wrapper">
          <select scz-cart-item-quantity-action="$">
              {$~ zerance.quantity_values :value:index }}
                  <option
                      value="{$=value}}"
                      {$? zerance.line_item.quantity != value }}
                      {$??}}
                          selected="selected"
                      {$?}}
                  >
                      {$=value}}
                  </option>
              {$~}}
          </select>
      </div>
  </script>
  
  <template id="scz-cart-remove-item-both">
      <div scz-cart-item-quantity-action="0" class="scz-cart-item__remove-trigger">
        <div class="scz-cart-item__remove align--center">
          <svg width="25" height="25" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M24.938 9.84044L23.9069 26.3377C23.8271 27.614 22.7687 28.6083 21.49 28.6083H11.5101C10.2313 28.6083 9.17288 27.614 9.09312 26.3377L8.06204 9.84044H6.51066C6.00912 9.84044 5.60254 9.43386 5.60254 8.93232C5.60254 8.43078 6.00912 8.0242 6.51066 8.0242H26.4894C26.9909 8.0242 27.3975 8.43078 27.3975 8.93232C27.3975 9.43386 26.9909 9.84044 26.4894 9.84044H24.938ZM23.0051 9.84044H9.99493L10.8671 25.6479C10.9025 26.2898 11.4333 26.7921 12.0761 26.7921H20.924C21.5668 26.7921 22.0975 26.2898 22.1329 25.6479L23.0051 9.84044ZM16.5 11.6567C16.9681 11.6567 17.3476 12.0362 17.3476 12.5043V24.1282C17.3476 24.5963 16.9681 24.9758 16.5 24.9758C16.0319 24.9758 15.6524 24.5963 15.6524 24.1282V12.5043C15.6524 12.0362 16.0319 11.6567 16.5 11.6567ZM12.8675 11.6567C13.3417 11.6567 13.7321 12.0297 13.7536 12.5034L14.2848 24.1896C14.3036 24.6045 13.9826 24.9562 13.5676 24.975C13.5562 24.9756 13.5449 24.9758 13.5335 24.9758C13.092 24.9758 12.7276 24.6307 12.7036 24.1899L12.0661 12.503C12.042 12.0604 12.3812 11.682 12.8238 11.6579C12.8384 11.6571 12.8529 11.6567 12.8675 11.6567ZM20.1325 11.6567C20.5758 11.6567 20.9351 12.016 20.9351 12.4593C20.9351 12.4739 20.9347 12.4885 20.9339 12.503L20.2997 24.1295C20.2739 24.6042 19.8814 24.9758 19.406 24.9758C18.9627 24.9758 18.6034 24.6165 18.6034 24.1732C18.6034 24.1586 18.6038 24.144 18.6046 24.1295L19.2388 12.503C19.2646 12.0283 19.6571 11.6567 20.1325 11.6567ZM14.0783 4.39171H18.9217C20.2591 4.39171 21.3433 5.47592 21.3433 6.81337V8.0242H11.6567V6.81337C11.6567 5.47592 12.7409 4.39171 14.0783 4.39171ZM14.1994 6.20795C13.7982 6.20795 13.4729 6.53322 13.4729 6.93445V8.0242H19.5271V6.93445C19.5271 6.53322 19.2018 6.20795 18.8006 6.20795H14.1994Z" fill="black"/>
          </svg>
          <p>{$#def.remove_label}}</p>
        </div>
      </div>
  </template>
  
  <template id="scz-cart-remove-item-only-icon">
      <div scz-cart-item-quantity-action="0" class="scz-cart-item__remove scz-cart-item__remove-icon">
        <img src="https://cdn.shopify.com/s/files/1/0562/8575/7497/files/close_black_24dp.svg?v=1649090633" alt="Delete">
      </div>
  </template>
  
  <template id="scz-cart-remove-item-only-text">
      <div scz-cart-item-quantity-action="0" class="scz-cart-item__remove scz-cart-item__remove-text">
          {$#def.remove_label}}
      </div>
  </template>
  `;
        function htmlToElement(html) {
          var templatesParent = document.createElement('div');
          templatesParent.innerHTML = "<div>" + html + "</div>";
          return templatesParent.firstChild;
        }
        const templates = htmlToElement(zSideCartTemplates);
        // [].forEach.call(templates, template => {
          document.body.append(templates);
        // });
      